import { render, staticRenderFns } from "./serviceNotAvalibale.vue?vue&type=template&id=5af7a582&scoped=true&"
import script from "./serviceNotAvalibale.vue?vue&type=script&lang=js&"
export * from "./serviceNotAvalibale.vue?vue&type=script&lang=js&"
import style0 from "./serviceNotAvalibale.vue?vue&type=style&index=0&id=5af7a582&scoped=true&lang=css&"
import style1 from "./serviceNotAvalibale.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7a582",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
